import { ClinicalCases } from "../modules"

export const ClinicalCasesPage = () => {
  return (
    <ClinicalCases/>
  )
}
